import React, { useCallback, useState } from 'react';

import ReactDOM from 'react-dom';

import classes from './exit-pixel.module.scss';

type ExitPixelProps = {
  onHover: () => void;
  blocked?: boolean;
  canBeTriggered?: 'once_per_session' | 'everytime';
};

export const ExitPixel = ({
  onHover,
  canBeTriggered = 'everytime',
  blocked,
}: ExitPixelProps) => {
  const [triggerable, setTriggerable] = useState(true);

  const onMouseOver = useCallback(() => {
    if (triggerable) onHover();
    if (canBeTriggered === 'once_per_session') setTriggerable(false);
  }, [triggerable]);

  if (typeof document === 'undefined' || !triggerable || blocked) return null;
  return ReactDOM.createPortal(
    <div className={classes.pixel} onMouseOver={onMouseOver} />,
    document.body,
  );
};
